import { type CacheConfig, Network, type RequestParameters, type Variables } from 'relay-runtime';

import { getAggEndpoint, getRequestBody } from '@atlassian/relay-endpoint';
import { getRelayExperimentalApis } from '@atlassian/relay-experimental-apis';

export const fetchFn = async (
	request: RequestParameters,
	variables: Variables,
	cacheConfig: CacheConfig,
) => {
	const endpoint = getAggEndpoint(request, cacheConfig);
	const body = getRequestBody(request, variables);
	return fetch(endpoint, {
		method: 'POST',
		credentials: 'same-origin',
		headers: {
			'content-type': 'application/json',
			'X-ExperimentalApi': getRelayExperimentalApis().join(','),
		},
		body,
	}).then((response) => {
		return response.json();
	});
};

export const network = Network.create(fetchFn);
